module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.projectTypeRevenue"
    }
  }), _vm._v("\n        " + _vm._s(_vm.title) + "\n    ")], 1), _vm._v(" "), (_vm.rows.length > 0 || _vm.$store.state.closedRows && _vm.$store.state.closedRows.length === 0) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                " + _vm._s(_vm._f("truncate")(props.row.description)) + "\n            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type : '-') + "\n            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 2474449646)
  }, [_vm._v("\n    >\n        "), _c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-22694666", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22694666"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/projects/typesRevenue.vue
// module id = 796
// module chunks = 0